/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const UnderlineIcon = /*#__PURE__*/ createSvgIcon(
  'UnderlineIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.75 17a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h8.5c.213 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219h-8.5zM10 14c-1.333 0-2.365-.413-3.094-1.238-.729-.826-1.093-1.92-1.093-3.282V3.996c0-.275.101-.51.305-.704C6.32 3.097 6.56 3 6.836 3c.276 0 .512.098.709.295a.965.965 0 01.295.708v5.603c0 .734.183 1.33.55 1.79.367.458.904.687 1.611.687.708 0 1.245-.23 1.614-.688.368-.46.552-1.056.552-1.79V3.995a.96.96 0 01.291-.704A.968.968 0 0113.17 3c.28 0 .52.098.72.295.199.196.299.431.299.706V9.48c0 1.361-.365 2.455-1.094 3.281-.73.827-1.76 1.24-3.094 1.24z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default UnderlineIcon;
